/**
 * IM消息列表
 * author: jiaheming
 * date: 2019/06/12
 */
import React from 'react';
import styled from 'styled-components';
import emtpy from '../../static/images/empty.png';

const IMEmptyStyle = styled.div`
    height: 100%;
    width: 100%;
    overflow: hidden;
`;

export default function IMEmpty(props) {
    return <IMEmptyStyle>{props.children}</IMEmptyStyle>;
}

const IMEmptyExampleStyle = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    overflow: hidden;
`;
const EmptyImgStyle = styled.img`
    display: block;
    margin-bottom: 17px;
    width: 100px;
    height: 85px;
`;
const EmptyText1Style = styled.div`
    margin: 4px auto 8px;
    color: rgba(51, 51, 51, 1);
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
`;
const EmptyText2Style = styled.div`
    margin: 0 auto;
    color: rgba(108, 111, 128, 1);
    font-size: 12px;
    font-weight: 400;
    line-height: 17px;
`;

function IMEmptyExample() {
    return (
        <IMEmptyExampleStyle>
            <EmptyImgStyle src={emtpy} />
            <EmptyText1Style>您还没有对话信息</EmptyText1Style>
            <EmptyText2Style>完善信息会为您带来更多可能哦~</EmptyText2Style>
        </IMEmptyExampleStyle>
    );
}
